<script setup lang="ts">
/**
 * Homepage block on what the CV editor does besides the form: example
 * phrases, translation into a copy, the cover letter in the CV's design and
 * autosave. Each card links to the page that explains it, where there is one.
 */
import { SUPPORTED_CV_LANGUAGES } from '~/constants/cvLanguages'

const { t } = useI18n()
const languageCount = SUPPORTED_CV_LANGUAGES.length

const cards = [
  { id: 'phrases', icon: 'bi-lightbulb', to: '/resume-examples' },
  { id: 'translate', icon: 'bi-translate', to: '/cv-languages#translate' },
  { id: 'coverLetter', icon: 'bi-envelope-paper', to: '/ai-cover-letter#cover-letter-pdf' },
  { id: 'autosave', icon: 'bi-cloud-check', to: '' },
] as const
</script>

<template>
  <section class="sofax surface-alt">
    <div class="section-space">
      <div class="shell">
        <SofaxSectionHeading
          :eyebrow="t('homepage.editorExtras.eyebrow')"
          :title="t('homepage.editorExtras.title')"
          :text="t('homepage.editorExtras.text')"
        />

        <ul class="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-4">
          <li v-for="card in cards" :key="card.id" class="card card-hover flex h-full flex-col p-[1.875rem]">
            <SofaxIconTile :icon="card.icon" />
            <h3 class="display-heading display-heading-5 mb-3 mt-6">{{ t(`homepage.editorExtras.cards.${card.id}.title`) }}</h3>
            <p class="!mb-6 grow text-base">{{ t(`homepage.editorExtras.cards.${card.id}.text`, { count: languageCount }) }}</p>
            <SofaxArrowLink v-if="card.to" :to="card.to" :label="t(`homepage.editorExtras.cards.${card.id}.link`)" />
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
